<template>
  <div class="container-fluid">
    <breadcrumbs></breadcrumbs>
    <router-view></router-view>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pb-3">
              <form method="post" :action="csvExportEndpoint">
                <input type="hidden" name="campaignId" :value="campaignId"/>
                <input type="hidden" name="companyId" :value="companyId"/>
                <input type="hidden" name="period" :value="period"/>
                <input type="hidden" name="status" :value="status"/>
                <input type="hidden" name="token" :value="getAuthToken"/>
                <button class="btn btn-info float-right">
                  Export as CSV
                </button>
              </form>
              <h3 class="card-title">Leads</h3>
            </div>
            <lead-grid
              :filters="variables"
              :role="getAuthUser.role.role_type"
              :query="query"
              :onClickLead="onClickHandler">
              <div slot="filter" class="filter-controls pull-right">
                <multiselect
                  id="company-filter"
                  v-if="!isClient"
                  :options="companies"
                  fieldName="companyName"
                  v-model="company"
                  :defaultValue="company"
                  name="company"
                  class="form-control"
                  placeholder="Select a company"
                  :isValid="true"
                ></multiselect>
                <!--<select v-model="companyId" v-if="!isClient" class="form-control" id="company-filter">-->
                  <!--<option selected value="0">All Companies</opti
                  on>-->
                  <!--<option v-for="company of companies" :key="company.id" :value="company.id">{{company.companyName}}</option>-->
                <!--</select>-->
                <select v-model="campaignId" v-if="!(isWhiteLabel && isClient)" :disabled="!isClient && companyId <= 0" class="form-control" id="campaign-filter">
                  <option selected value="0">All Campaigns</option>
                  <option v-for="campaign of campaigns" :key="campaign.id" :value="campaign.id">{{campaign.campaignName}}</option>
                </select>
                <select v-model="period" class="form-control" id="period-filter">
                  <option v-for="period of periods" :key="period.value" :value="period.value">{{period.title}}</option>
                </select>
                <select v-model="status" class="form-control" id="status-filter">
                  <option v-for="status of statuses" :key="status.value" :value="status.value">{{status.title}}</option>
                </select>
              </div>
            </lead-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LeadGrid from '@/components/LeadGrid';
import COMPANIES from '@/graphql/Companies/Companies.gql';
import ASSIGNABLE_CAMPAIGNS from '@/graphql/Campaigns/AssignableCampaigns.gql';
import ADMIN_LEADS from '@/graphql/Leads/Admin.gql';
import CLIENT_LEADS from '@/graphql/Leads/Client.gql';
import Multiselect from '@/components/CustomMultiselect';

export default {
  name: 'Leads',
  components: {
    LeadGrid,
    Multiselect,
  },
  computed: {
    ...mapGetters(['getAuthUser', 'getAuthToken', 'isWhiteLabel']),

    isClient() {
      return this.getAuthUser.role.role_type === 'client';
    },

    query() {
      return this.isClient ? CLIENT_LEADS : ADMIN_LEADS;
    },

    variables() {
      return {
        campaignId: parseInt(this.campaignId),
        companyId: parseInt(this.companyId),
        period: this.period,
        status: this.status,
      };
    },

    companyId() {
     return (this.company) ? this.company.id : 0;
    }
  },

  data() {
    return {
      companies: [],
      campaigns: [],
      periods: [
        {
          value: 'today',
          title: 'Today',
        },
        {
          value: 'yesterday',
          title: 'Yesterday',
        },
        {
          value: 'last-7-days',
          title: 'Last 7 days',
        },
        {
          value: 'week',
          title: 'This week',
        },
        {
          value: 'month',
          title: 'This month',
        },
        {
          value: 'last-month',
          title: 'Last month',
        },
        {
          value: 'last-6-month',
          title: 'Last 6 months',
        },
      ],
      statuses: [
        {
          value: '',
          title: 'Any status',
        },
        {
          value: 'completed',
          title: 'Completed',
        },
        {
          value: 'partial',
          title: 'Partial',
        },
      ],
      campaignId: 0,
      company: null,
      period: 'last-7-days',
      status: '',
      csvExportEndpoint: `${process.env.API_HOST}/csv-export`,
    };
  },

  apollo: {
    companies: {
      query: COMPANIES,
      fetchPolicy: 'network-only',
      result({ data, loading }) {
        if (!loading) {
          this.companies = data.companies.result;
        }
      },
      variables() {
        return {
          limit: -1,
          status: true,
        };
      },
      skip() {
        return this.isClient;
      },
    },

    campaigns: {
      query: ASSIGNABLE_CAMPAIGNS,
      fetchPolicy: 'network-only',
      update(data) {
        return data.assignableCampaigns;
      },
      result({ data, loading }) {
        if (!loading) {
          this.campaigns = data.assignableCampaigns;
        }
      },
      variables() {
        return {
          companyId: parseInt(this.companyId),
        };
      },
      skip() {
        return !this.isClient && this.companyId <= 0;
      },
    },
  },

  methods: {
    onClickHandler(row) {
      if (this.$router.canSee(['leads.find'])) {
        this.$router.push({ name: 'Lead', params: { id: row.id } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-controls {}
@media (max-width: 768px) {
  .filter-controls {
    select {
      margin-bottom: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Leads/Leads.vue